import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-white border-t border-gray-200 py-4 px-6">
      <div className="flex flex-col md:flex-row justify-between items-center">
        <div className="text-sm text-gray-600">
          &copy; {currentYear} MarketPlace. Tous droits réservés.
        </div>
        <div className="mt-2 md:mt-0 flex space-x-4">
          <a href="#" className="text-sm text-gray-600 hover:text-tertiary-600">Conditions d'utilisation</a>
          <a href="#" className="text-sm text-gray-600 hover:text-tertiary-600">Politique de confidentialité</a>
          <a href="#" className="text-sm text-gray-600 hover:text-tertiary-600">Contact</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;